// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetReferentsByLessonIdRequestModel from '../../model/get-referents-by-lesson-id-request-model';
import GetReferentsByLessonIdRequestDTO from '../dto/get-referents-by-lesson-id-request-dto';
import dtoSchema from '../schemas/get-referents-by-lesson-id-request-schema';

export default abstract class GetReferentsByLessonIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetReferentsByLessonIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetReferentsByLessonIdRequestDTO>): GetReferentsByLessonIdRequestModel;
  static toModel(dto: DeepPartial<GetReferentsByLessonIdRequestDTO> | undefined | null): GetReferentsByLessonIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetReferentsByLessonIdRequestDTO> | undefined | null): GetReferentsByLessonIdRequestModel | undefined {
    return dto ? new GetReferentsByLessonIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetReferentsByLessonIdRequestModel> | GetReferentsByLessonIdRequestModel): GetReferentsByLessonIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetReferentsByLessonIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetReferentsByLessonIdRequestModel, can not map to GetReferentsByLessonIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
